import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify, {
  iconfont: "md",
  theme: {
    primary: "#54B0E4",
    secondary: "#FFFF00",
    accent: "#54B0E4",
    error: "#FF5252",
    info: "#2196F3",
    success: "#4CAF50",
    warning: "#FFC107"
  }
});
export default new Vuetify({
});
